import script from "./BaseCmDialog.vue?vue&type=script&setup=true&name=BaseCmDialog&lang=js"
export * from "./BaseCmDialog.vue?vue&type=script&setup=true&name=BaseCmDialog&lang=js"

const __exports__ = script;

export default __exports__